import Api from '@/api/manager.js';

const state = {
  error: null,
  loading: false,
  managers: [],
  data: null
};

const actions = {
  fetch ({commit}) {
    commit('fetch')

    Api.fetch()
      .then(data => commit('fetchSuccess', data))
      .catch(err => commit('fetchFailure', err))
  },

  saveOne ({commit, dispatch}, model) {
    commit('save')

    Api.updateOne(model)
      .then(data => commit('saveSuccess', data))
      .catch(err => commit('saveFailure', err))
  },

  fetchPersonalManagerInfo ({commit}) {
    commit('fetchPersonalManagerInfo')

    Api.fetchPersonalManager()
      .then(data => commit('fetchPersonalManagerInfoSuccess', data))
      .catch(err => commit('fetchPersonalManagerInfoFailure', err))
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, data) {
    state.loading = false
    state.managers = data
  },

  fetchFailure (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  },

  update (state, {model, data}) {
    Object.assign(model, data)
  },

  save (state) {
    state.loading = true
  },

  saveSuccess (state, data) {
    state.managers = data
    state.loading = false
  },

  saveFailure (state, err) {
    state.loading = false
    state.error = err
    console.error(err)
  },

  fetchPersonalManagerInfo (state) {
    state.loading = true
  },

  fetchPersonalManagerInfoSuccess (state, data) {
    state.data = data
    state.loading = false
  },

  fetchPersonalManagerInfoFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  }
}

const getters = {
  error(state) {
    return state.error;
  },

  loading(state) {
    return state.loading;
  },

  list(state) {
    return state.managers;
  },

  manager(state) {
    return state.data;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
